<template>
  <div id="app">
      <Head></Head>
      <transition name="component-fade" mode="out-in">
        <router-view class="child-view"></router-view>
      </transition>
  </div>
</template>
<script>
    import Head from '@/layouts/Header'
    export default {
        name: 'App',
        components: {
            Head
        },
        methods: {
            // /**
            //  * @description获取动态菜单--咨询
            //  * */
            // getCateList (){
            //     this.$xhr(this.$api.articleCategory, {}).then(res => {
            //         res.map((v)=>{
            //             v.path = '/consultation?type='+v.id
            //            return v
            //         })
            //         localStorage.zixun = JSON.stringify(res)
            //     })
            // },
            // /**
            //  * @description获取动态菜单--案例
            //  * */
            // getCaseList (){
            //     this.$xhr(this.$api.casesCategory, {}).then(res => {
            //         res.map((v)=>{
            //             v.path = '/case?type='+v.id
            //             return v
            //         })
            //         localStorage.case = JSON.stringify(res)
            //     })
            // },
        },
        mounted() {
            // this.getCateList()
            // this.getCaseList()
        }
    }
</script>
<style lang="scss">
</style>
